import { render, staticRenderFns } from "./importCustomer.vue?vue&type=template&id=af255024&scoped=true"
import script from "./importCustomer.vue?vue&type=script&lang=js"
export * from "./importCustomer.vue?vue&type=script&lang=js"
import style0 from "./importCustomer.vue?vue&type=style&index=0&id=af255024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af255024",
  null
  
)

export default component.exports